/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SupportService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Login Via Token
     * ### Get Support Token
     *
     * Gets an access token to log into the bug tracking platform
     *
     * **Permissions Required**:
     * `can_access_support`
     * @returns any Successful Response
     * @throws ApiError
     */
    public getSupportLoginViaToken(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/support/get_magic_link',
            errors: {
                404: `Not found`,
            },
        });
    }
    /**
     * Login Via Token
     * ### Get Support Token
     *
     * Gets an access token to log into the bug tracking platform
     *
     * **Permissions Required**:
     * `can_access_support`
     * @returns any Successful Response
     * @throws ApiError
     */
    public getSupportLoginViaTokenVLatest(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/support/get_magic_link',
            errors: {
                404: `Not found`,
            },
        });
    }
}
